import { render } from "./reportWaiterNamePerf.vue?vue&type=template&id=15d02fc2"
import script from "./reportWaiterNamePerf.vue?vue&type=script&lang=js"
export * from "./reportWaiterNamePerf.vue?vue&type=script&lang=js"

import "./reportWaiterNamePerf.vue?vue&type=style&index=0&id=15d02fc2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__